
import Msg from 'vux/src/components/msg/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'

export default {
components: {
Msg,
Divider,
XButton,
XHeader
},
data () {
return {
workList: [],
id: '',
loading: true
}
},
created () {
this.id = this.$route.query.id
},
methods: {
backUp () {
this.$router.go(-1)
}
}
}



// WEBPACK FOOTER //
// ./src/components/onboard/error.vue